import { useHandleTrial } from "./hooks";

type Props = {
	validDtEndBasicInitialSetUp?: string | null;
};

export const Trial = ({ validDtEndBasicInitialSetUp }: Props) => {
	const { isExistValidDtForTrial, isFinishedTrial, formatTrialFinishDate, remainingDays } = useHandleTrial({
		validDtEndBasicInitialSetUp,
	});

	/**
	 * 終了日が存在しない場合
	 */
	if (!isExistValidDtForTrial) return <></>;

	/**
	 * トライアル期間が終了している場合
	 */
	if (isFinishedTrial) return <p className="text-brand">トライアル期間は終了しました</p>;

	return (
		<div className="text-sm">
			<p className="text-brand">トライアル期間中</p>
			<p>{formatTrialFinishDate} まで</p>
			<p>残り{remainingDays}日</p>
		</div>
	);
};
